<template>
    <div class="warranty-message">
        <inc-warranty
            v-model="showDialog"
            :warrenties="warrenties"
            :component="component"
        />
        <v-tooltip
            bottom
        >
            <template v-slot:activator="{ on, attrs }">
                <a @click="onClick">
                    <v-icon
                        color="error"
                        size="30"
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-alert
                    </v-icon>
                </a>
            </template>
            <span style="font-size: 10pt">Gewährleistung beachten</span>
        </v-tooltip>
    </div>
</template>

<script>
import IncWarranty from "@/modules/inc/warranty/IncWarranty.vue";
export default {
    name: "IncWarrantyButton",
    components: {
        IncWarranty
    },

    props: {
        warrenties: {

        },
    },

    data: () => ({
        showDialog: false,
        select    : null,
        component : null,
    }),

    methods: {
        onClick () {
            this.component = null;
            this.showDialog = true;
        },

        show (component) {
            this.select = component;
            this.component = component;
            this.showDialog = true;

        }
    }
}
</script>

<style scoped>

.warranty-message {
    left: calc(25%  - 55px);
    margin-top: 0;
    margin-right: 8px;
}

</style>